import styled from 'styled-components'

import colors from 'styles/colors'

export enum SharedMediaDirection {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing'
}

interface DirectionTabsProps {
  direction: SharedMediaDirection
  setDirection: (value: SharedMediaDirection) => void
}

export const SharedMediaFilterTabs = ({
  direction,
  setDirection
}: DirectionTabsProps) => {
  return (
    <DirectionContainer>
      <DirectionTab
        $active={direction === SharedMediaDirection.INCOMING}
        onClick={() => setDirection(SharedMediaDirection.INCOMING)}
      >
        Incoming
      </DirectionTab>

      <DirectionTab
        $active={direction === SharedMediaDirection.OUTGOING}
        onClick={() => setDirection(SharedMediaDirection.OUTGOING)}
      >
        Outgoing
      </DirectionTab>
    </DirectionContainer>
  )
}

const DirectionContainer = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, ${colors.whiteSmoke} 55.26%, #ededed 100%);
  height: 4rem;
  min-height: 4rem;
  max-height: 4rem;
  width: max-content;
  padding: 0 0.5rem;
  border-radius: 2rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  gap: 0.5rem;
  overflow: hidden;
  box-sizing: border-box;
`

const DirectionTab = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  min-height: 3rem;
  max-height: 3rem;
  padding: 0 1rem;
  box-sizing: border-box;

  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.5rem;
  letter-spacing: 0.04em;
  border-radius: 2rem;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    ${props => !props.$active && `background: #dedfe3;`}
  }

  ${props =>
    props.$active &&
    `
      color: white;
      background: ${colors.slateBlue};
  `}
`